import {
  AUTH_HOST,
  AUTH_USER,
  AUTH_CREDENTIALS,
  AUTH_SCOPES
} from '../config/config'
import sha1 from 'sha1'
import { get, post } from './axiosService'
import { getTokenForClient, getTokenForUser } from './oauthService'

const CREATE_USER_URL = 'rest/api/v1/backAuth/createUser'
const GET_USER_DETAILS_URL = 'rest/api/v1/backAuth/getUser'
const REQUEST_PASSWORD_RESET_URL = 'rest/api/v1/backAuth/requestPasswordReset'
const ALLOW_PASSWORD_RESET_URL = 'auth/allowPasswordReset'
const CHANGE_PASSWORD_URL = 'rest/api/v1/backAuth/changePassword'

class UserService {

  static async init () {
    const now = new Date()

    while (UserService.auth == null || UserService.auth.expires_at < now) {
      UserService.auth = await getTokenForClient(AUTH_USER, AUTH_CREDENTIALS, AUTH_SCOPES)

      if (UserService.auth === null) {
        continue
      }

      if (UserService.auth.expires_in) {
        UserService.auth.expires_at = new Date(now.getTime() + UserService.auth.expires_in * 1000)
      }
    }
  }

  static async registerUser (activationCode, email, password) {
    try {
      await UserService.init()

      const data = {
        code: activationCode,
        email: email,
        nickname: email,
        password: sha1(password),
        agreed: 'true'
      }

      const token = UserService.auth.access_token
      let response = await post(`${AUTH_HOST}/${CREATE_USER_URL}`, data, token)
      // console.log('INFO','userService.registerUser','registerResponse', response)
      if (response.success !== true) {
        throw new Error(response.errors.join(','))
      }

      return response
    } catch (error) {
      throw error
    }
  }

  static async login (email, password, scopes) {
    try {
      await UserService.init()

      let data = {
        nickname: email,
        email: email,
        withData: true
      }

      const token = UserService.auth.access_token
      let response = await post(`${AUTH_HOST}/${GET_USER_DETAILS_URL}`, data, token)
      // console.log('INFO','userService.login', 'userInfo', response)

      if (response.success === true && response.user.username) {
        let auth = await getTokenForUser(response.user.username, password, scopes)
        if (auth.expires_in) {
          auth.expires_at = new Date(new Date().getTime() + auth.expires_in * 1000)
        }
        // console.log('INFO','userService.login', 'auth', auth)
        // add user info to auth
        auth.user = response.user
        return auth
      } else {
        throw new Error(response.errors.join(','))
      }

    } catch (error) {
      throw error
    }
  }

  static async requestPasswordReset (email) {
    try {
      await UserService.init()

      let data = {
        nickname: email,
      }

      const token = UserService.auth.access_token
      let response = await post(`${AUTH_HOST}/${REQUEST_PASSWORD_RESET_URL}`, data, token)
      if (response.success === true && response.maxSeconds) {
        // console.log('INFO', 'userService.requestPasswordReset', 'resetRequest', response)
        return response
      } else {
        throw new Error(response.errors.join(','))
      }
    } catch (error) {
      throw error
    }
  }

  static async resetPassword (token, signature, password) {
    try {
      await UserService.init()

      let response = await get(`${AUTH_HOST}/${ALLOW_PASSWORD_RESET_URL}`, { token: token, signature: signature })
      // console.log('INFO', 'userService.resetPassword', 'allowRequest', typeof response, response)
      if (typeof response === 'string') {
        throw new Error(response.replace(/^[\s\S]*<p>([\s\S]*?)<\/p>[\s\S]*$/gm, '$1'))
      } else if (response.success === true && response.data && response.data.username) {
        const token = UserService.auth.access_token
        let data = {
          username: response.data.username,
          newpassword: sha1(password)
        }
        response = await post(`${AUTH_HOST}/${CHANGE_PASSWORD_URL}`, data, token)
        // console.log('INFO', 'userService.resetPassword', 'change Password', response)
        return response
      } else {
        throw new Error('Unbekannter Fehler')
      }
    } catch (error) {
      throw error
    }
  }
}

UserService.auth = null

export default UserService
